import React, { useEffect, useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAuth } from '@/contexts/AuthContext';
import { DueList } from '@/components/maintenancePlans/DueList';
import { PlanList, ReminderSettings } from '@/components/maintenancePlans/PlanList';
import { PlanEditor } from '@/components/maintenancePlans/PlanEditor';

export default function MaintenancePlansPage() {
  const { api } = useAuth();
  const [defaults, setDefaults] = useState(null);
  const [edit, setEdit] = useState(null); // {id} | {id: null} for new
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => { api.get('/maintenance-plans/defaults').then(r => setDefaults(r.data)); }, [api]);
  const open = (id) => setEdit({ id });
  return (
    <div data-testid="maintenance-plans-page" className="p-6 lg:p-8 max-w-6xl">
      <h1 className="text-2xl font-bold text-slate-900">Maintenance plans</h1>
      <p className="text-sm text-slate-500 mt-1 mb-6">Each client's repeat schedule for roof treatment, gutters, washes and driveways — and what's coming due.</p>
      <Tabs defaultValue="due">
        <TabsList>
          <TabsTrigger data-testid="mplan-tab-due" value="due">Due soon</TabsTrigger>
          <TabsTrigger data-testid="mplan-tab-plans" value="plans">All plans</TabsTrigger>
          <TabsTrigger data-testid="mplan-tab-settings" value="settings">Reminders</TabsTrigger>
        </TabsList>
        <TabsContent value="due" className="mt-4"><DueList onOpen={open} refreshKey={refreshKey} /></TabsContent>
        <TabsContent value="plans" className="mt-4"><PlanList onOpen={open} onNew={() => setEdit({ id: null })} refreshKey={refreshKey} /></TabsContent>
        <TabsContent value="settings" className="mt-4"><ReminderSettings /></TabsContent>
      </Tabs>
      <PlanEditor open={!!edit} planId={edit?.id} defaults={defaults} onClose={() => setEdit(null)}
        onSaved={() => { setEdit(null); setRefreshKey(k => k + 1); }} />
    </div>
  );
}
